import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "@/shared/config/axios-interceptor";
import avatar from "@/assets/img/avatar.png";
import { formatPhone } from "@/shared/utils/ultils";
import dayjs from "dayjs";
const Group = () => {
  const listStatus = [
    { name: "Nhóm 1", value: "1" },
    { name: "Nhóm 2", value: "2" },
    { name: "Nhóm 3", value: "3" },
  ];

  const [active, setActive] = useState("1");
  const [listUser, setListUser] = useState<any>([]);
  const getData = async () => {
    try {
      const res = await axios.get(`/user/group?active=` + active);
      setListUser(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [active]);

  return (
    <div className="wrapper">
      <div className="container-web bg4">
        <div
          className="d-flex align-items-center justify-content-between px-3"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            background: "#0262b0",
            height: 50,
            maxWidth: 500,
            margin: "auto",
            color: "#fff",
          }}
        >
          <Link to="/account">
            <i
              style={{ color: "#fff" }}
              className="fa-solid fa-chevron-left"
            ></i>
          </Link>
          <div>BÁO CÁO NHÓM</div>
          <div></div>
        </div>
        <div style={{ paddingTop: 50 }}></div>

        <div
          className="d-flex px-3 mt-3 gap-2 align-items-center"
          style={{ fontSize: 13 }}
        >
          {listStatus.map((item, index) => {
            return (
              <div
                onClick={() => setActive(item.value)}
                className="px-2 rounded-1"
                key={index}
                style={{
                  border:
                    active === item.value
                      ? "1px solid #fff"
                      : "1px solid transparent",
                }}
              >
                {item?.name}
              </div>
            );
          })}
        </div>

        <div className="p-3" style={{ fontSize: 14 }}>
          {listUser?.length == 0 && (
            <div className="text-center mt-5">Không có thành viên nào</div>
          )}
          {listUser?.map((item: any, index: number) => {
            return (
              <div className="d-flex justify-content-between border-bottom py-2 align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <img
                      className="rounded-circle"
                      style={{ width: 50, height: 50 }}
                      src={item?.avatar ? item?.avatar : avatar}
                    />
                  </div>
                  <div>
                    <div className="fw-bold">{item?.username}</div>
                    <div style={{ fontSize: 12 }}>Nạp: {item?.totalNap}</div>
                    <div style={{ fontSize: 12 }}>Rút: {item?.totalRut}</div>
                  </div>
                </div>
                <div className="text-end">
                  <div>SĐT: {formatPhone(item?.phone)}</div>
                  <div style={{ fontSize: 12 }}>Mời: {item?.inviteLevel2}</div>
                  <div style={{ fontSize: 12 }}>
                    Tham gia: {dayjs(item?.createdDate).format("DD/MM/YYYY")}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ paddingBottom: 120 }}></div>
      </div>
    </div>
  );
};

export default Group;
